import { createSelector } from '@ngrx/store';
import { createFilteringFieldsSelector } from '../create-filtering-fields/create-filtering-fields.selector';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createChosenOptionsSelector = (filterInstanceId: string) =>
  createSelector(createFilteringFieldsSelector(filterInstanceId), (allFields) => {
    const allOptions = allFields.flatMap((field) => Object.values(field.options));
    return allOptions.filter((option) => option.isDisplayed && option.isChecked);
  });
